import { render, staticRenderFns } from "./DrawTemplate.vue?vue&type=template&id=c05cd09c&scoped=true"
import script from "./DrawTemplate.vue?vue&type=script&lang=js"
export * from "./DrawTemplate.vue?vue&type=script&lang=js"
import style0 from "./DrawTemplate.vue?vue&type=style&index=0&id=c05cd09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05cd09c",
  null
  
)

export default component.exports